<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="" v-if="$hasPermission([62, 173, 123])">
          <router-link :to="{ name: 'noticeAdd' }" slot="beforeDefinedSearch">
            <el-button type="success">创建新消息</el-button>
          </router-link>
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-form-item label="所属国家">
            <el-select v-model="searchData.country" clearable placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息标题">
            <el-input v-model="searchData.title" placeholder="标题" />
          </el-form-item>
          <el-form-item label="消息类型">
            <el-select v-model="searchData.notice_type" clearable placeholder="请选择">
              <el-option
                v-for="item in ds.types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="() => {this.refresh = true;}">查询</el-button>
          </el-form-item>
        </el-form>
        <jm-tableList
          url="/index/europe_notice/getNoticeList"
          :search-data="searchData"
          :refresh.sync="refresh">
          <el-table-column
            slot="file_name"
            label="文件名">
            <template slot-scope="scope">
              <span style="color: #6495ED"><img :src="scope.row.file_icon" align="absmiddle" /> {{ scope.row.file_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            slot="lastColumn"
            label="操作"
            :width="$hasPermission([62, 173, 123]) ? 220 : 100">
            <template slot-scope="scope">
              <router-link :to="{ name: 'noticeShow', params: { id: scope.row.id } }">
                <el-button size="small" type="success">查看</el-button>
              </router-link>
              <router-link :to="{ name: 'noticeEdit', params: { id: scope.row.id } }" v-if="$hasPermission([62, 173, 123])">
                <el-button size="small" type="primary">编辑</el-button>
              </router-link>
              <el-button size="small" type="danger" @click="handleDelete(scope)" v-if="$hasPermission([62, 173, 123])">删除</el-button>
            </template>
          </el-table-column>
        </jm-tableList>
      </div>
    </div>
  </div>
</template>
<style>
  .el-dialog{
    width: 30%;
    min-width: 450px;
  }
  .el-form-item {
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false,
      ds: {},
      searchData: {}
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    handleDelete(scope) { // 删除
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/europe_notice/delNotice',
          data: { id: scope.row.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.refresh = true;
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    fetchDictData() {
      this.$http
        ._get({
          url: '/index/europe_notice/dictData'
        })
        .then(({ data }) => {
          this.ds = data;
        });
    }
  },
  mounted() {
    this.fetchDictData();
  }
};
</script>
